import React, {useEffect, useState, useRef} from 'react'
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import {Form, Button, message, Skeleton, Row} from 'antd';
import {cerrarNomina} from '../../../../apis/ProcesoNominaApi';
import {emit} from '../../../../apis/TimbradoApi';
import AnioPeriodo from '../../../../components/forms/anio_periodo';
import {status_period} from '@app/constants/period';
import {status_recibo_nomina} from '@app/constants/reciboNomina';
import _ from 'lodash'
import Result from './result'

const routes = [
  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Distribución Contable</span>
      </>
    ),
  }
];

const DistribucionContable = () => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false);
  const [objectSelected, setObjectSelected] = useState(null);
  const [disabledForm, setDisabled] = useState(true);
  const [header, setHeader] = useState(null);
  const [period, setPeriod] = useState(null);
  
  // Referencia al componente Result para acceder a los datos de la póliza
  const resultRef = useRef(null);

  const handleOk = async ({concepto}) => {
    setLoading(true);
    let success = false;
    const fields = form.getFieldsValue();
    const payload = {
      ...fields
    }
    const response = await cerrarNomina(payload);
    success = response.ok;
    if(response.ok){
      // setID(response.payload);
      message.success('Se proceso correctamente la nomina!');
    }

    setLoading(false);
    if(success){
      await resetBody();
    }
  }

  const handleTimbrarOk = async ({concepto}) => {
    setLoading(true);
    let success = false;
    const fields = form.getFieldsValue();
    const payload = {
      ...fields
    }
    await emit(payload);
    //await emitGet('recibo.pdf');
    setLoading(false);
    if(success){
      await resetBody();
    }
  }

  const sendToOdoo = async ({concepto}) => {
    // Verificar si hay una póliza generada en el componente Result
    if (resultRef.current && resultRef.current.getPolizaData) {
      const polizaData = resultRef.current.getPolizaData();
      
      if (!polizaData) {
        message.warning('Primero debes generar una póliza');
        return;
      }

      // Verificar que la póliza esté balanceada
      if (Math.abs(polizaData.resumen.balance) >= 0.01) {
        message.error('No se puede enviar una póliza desbalanceada a Odoo');
        return;
      }

      setLoading(true);
      
      try {
        // Simular envío a Odoo con los datos reales de la póliza
        // Aquí deberías hacer la llamada real a la API de Odoo
        const payload = {
          header: header,
          polizaData: polizaData,
          definicionId: resultRef.current.getDefinicionSeleccionada()
        };
        
        // Simular llamada async
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        message.success('Póliza enviada a Odoo correctamente!');
        
        // Opcional: resetear después del envío exitoso
        // await resetBody();
        
      } catch (error) {
        console.error('Error al enviar a Odoo:', error);
        message.error('Error al enviar la póliza a Odoo');
      } finally {
        setLoading(false);
      }
    } else {
      message.warning('Primero debes generar una póliza');
    }
  }

  const resetBody = async ()=>{
    let values = await form.getFieldValue();
    form.resetFields();
    form.setFieldsValue({
      periodo_id: values.periodo_id,
      anio: values.anio,
      num_periodo: values.num_periodo,
    });
  }

  const onBlurHeader = async (values, period)=> {
    setHeader(values)
    if(values?.anio && values?.num_periodo && values?.periodo_id){
      setDisabled(false);
    }else{
      setDisabled(true);
    }

    if(period){
      setPeriod(period);
    }else{
      setPeriod(null)
    }
  }

  return <PageApp
    routes={routes}
    title={'Distribución Contable'}>
      <AnioPeriodo onBlur={onBlurHeader} form={form} disabledForm={objectSelected && objectSelected.id > 0}/>
      <br/>
      {
        loading ? <Skeleton active={loading} />: <>
          {
            header && !disabledForm && <Result ref={resultRef} header={header} onSendToOdoo={sendToOdoo} loading={loading} />
          }
        </>
      }
   </PageApp>
}

export default DistribucionContable;